var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.testAnswerDocument.type === 'HEURISTICS')?_c('div',[_c('HeuristicsAnalytics')],1):_c('div',[_c('UserAnalytics')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }